import React from "react";
import DocumentLegal from "../site/DocumentLegal";

function LegalNotice() {
  return (
    <DocumentLegal>
      <h1>Mentions Légales</h1>
      <p className="gs-doc-date">Dernière mise à jour : avril 2026</p>

      <section>
        <h2>1. Éditeur</h2>
        <p>
          Le site <strong>gymnote.fr</strong> et l'application mobile{" "}
          <strong>GymNote</strong> sont édités par :
        </p>
        <p>
          <strong>Mathis Le Berrigaud</strong><br />
          Développeur indépendant<br />
          E-mail : <a href="mailto:contact@gymnote.fr">contact@gymnote.fr</a>
        </p>
      </section>

      <section>
        <h2>2. Directeur de la publication</h2>
        <p>Mathis Le Berrigaud</p>
      </section>

      <section>
        <h2>3. Hébergement</h2>
        <p>
          Le site et l'API GymNote sont hébergés par :<br />
          <strong>IONOS SE</strong><br />
          Elgendorfer Str. 57, 56410 Montabaur, Allemagne<br />
          Serveurs situés en France (Union européenne)<br />
          <a href="https://www.ionos.fr" target="_blank" rel="noreferrer">www.ionos.fr</a>
        </p>
      </section>

      <section>
        <h2>4. Propriété intellectuelle</h2>
        <p>
          L'ensemble du contenu du site gymnote.fr et de l'application GymNote
          (textes, images, logos, icônes, pictogrammes, code source) est protégé
          par le droit d'auteur et le droit de la propriété intellectuelle français
          et international. Toute reproduction, représentation, modification,
          publication ou adaptation de tout ou partie des éléments du site ou de
          l'application, quel que soit le moyen ou le procédé utilisé, est
          interdite sans autorisation écrite préalable de Mathis Le Berrigaud.
        </p>
      </section>

      <section>
        <h2>5. Données personnelles et RGPD</h2>
        <p>
          Le traitement des données personnelles des utilisateurs est décrit dans
          notre{" "}
          <a href="/privacy">Politique de Confidentialité</a>.
          Conformément au Règlement Général sur la Protection des Données (RGPD –
          UE 2016/679) et à la loi Informatique et Libertés modifiée, vous disposez
          de droits sur vos données (accès, rectification, effacement, portabilité,
          opposition). Pour exercer ces droits, contactez-nous à{" "}
          <a href="mailto:contact@gymnote.fr">contact@gymnote.fr</a>.
        </p>
        <p>
          Vous pouvez également introduire une réclamation auprès de la CNIL :{" "}
          <a href="https://www.cnil.fr" target="_blank" rel="noreferrer">www.cnil.fr</a>.
        </p>
      </section>

      <section>
        <h2>6. Cookies</h2>
        <p>
          Le site gymnote.fr utilise uniquement des cookies techniques strictement
          nécessaires au fonctionnement du site (maintien de session). Aucun cookie
          publicitaire ou de suivi n'est déposé.
        </p>
      </section>

      <section>
        <h2>7. Liens hypertextes</h2>
        <p>
          Le site gymnote.fr peut contenir des liens vers des sites tiers. GymNote
          n'est pas responsable du contenu de ces sites ni de leur politique de
          confidentialité.
        </p>
      </section>

      <section>
        <h2>8. Limitation de responsabilité</h2>
        <p>
          GymNote s'efforce d'assurer l'exactitude et la mise à jour des
          informations diffusées sur ce site, mais ne peut garantir l'exhaustivité
          ou l'absence d'erreurs. GymNote décline toute responsabilité pour tout
          dommage résultant de l'utilisation du site ou de l'application.
        </p>
      </section>

      <section>
        <h2>9. Médiation de la consommation</h2>
        <p>
          Conformément à l'article L616-1 du Code de la consommation, en cas de
          litige non résolu à l'amiable, vous pouvez recourir gratuitement au
          médiateur de la consommation :<br />
          <strong>CM2C</strong> – Centre de Médiation et de Consommation des
          Conciliateurs de Justice<br />
          14 rue Saint-Jean – 75017 Paris<br />
          <a href="https://www.cm2c.net" target="_blank" rel="noreferrer">www.cm2c.net</a>
        </p>
      </section>

      <section>
        <h2>10. Contact</h2>
        <p>
          Pour toute question relative au site ou à l'application :{" "}
          <a href="mailto:contact@gymnote.fr">contact@gymnote.fr</a>
        </p>
      </section>
    </DocumentLegal>
  );
}

export default LegalNotice;
